import { Avatar, Button } from 'antd';
import { getUserManager } from '../../auth/oidc';

export default function KeycloakAuthButton({ returnTo }: { returnTo: string }) {
  const handleLogin = () => {
    getUserManager()
      .signinRedirect({ state: { returnTo } })
      .catch((error) =>
        console.error('Failed to start Keycloak login:', error),
      );
  };

  return (
    <Button
      icon={
        <Avatar
          shape={'square'}
          src={'/keycloak-logo.svg'}
          style={{ width: 20, height: 20, marginRight: 16 }}
        />
      }
      iconPosition={'start'}
      style={{ width: 240, height: 40, justifyContent: 'flex-start' }}
      onClick={handleLogin}
    >
      Continue with Keycloak
    </Button>
  );
}
